import firebase from "firebase";
import DB_PATH from "../DB_PATH";
import { Author } from "../../types/Author";
import { firestore } from "../firebase";
import { uploadMedia } from "../media/cloudflareMedia";

// Function to edit an author in Firebase Firestore
export async function editAuthor(
  authorId: string,
  newData: any
): Promise<void> {
  try {
    const db = firebase.firestore();
    const authorRef = db.collection(DB_PATH.AUTHOR).doc(authorId);

    const imageProfilePhotoURL = newData.imageprofilePhotoURL;
    const coverPhotoURL = newData.imagecoverURL;

    updateAuthor(newData);
    console.log("ImageProfilePhotoURL", imageProfilePhotoURL);
    uploadImage(newData, imageProfilePhotoURL, "profilePhotoURL");

    uploadImage(newData, coverPhotoURL, "coverImageURL");

    //await authorRef.update(newData);
    console.log("Author updated successfully");
  } catch (error) {
    console.error("Error updating author:", error);
  }
}
const updateAuthor = async (author: Author) => {
  //@ts-ignore
  delete author["imageprofilePhotoURL"]; // Assuming 'image' is a property you want to remove
  delete author["imagecoverImageURL"]; // Assuming 'image' is a property you want to remove

  try {
    await firestore
      .collection(DB_PATH.AUTHOR)
      .doc(author.id)
      .set(author, { merge: true });
    console.log("Product updated successfully");
  } catch (error: any) {
    console.log("Error updating product:", error.code);
  }

  return "";
};
const uploadImage = async (
  item: any,
  imageFile: File,
  imageId: string
): Promise<void> => {
  console.log("ImageFile", imageFile);

  if (!imageFile) return;

  try {
    console.log("ImageFile", imageFile);
    const uploaded = await uploadMedia({
      body: imageFile,
      kind: "image",
      fileName: imageFile.name,
      firebasePath:
        `${DB_PATH.AUTHOR}/${item.id}/${imageId}/${imageFile.name}`,
    });
    const downloadURL = uploaded.url;

    console.log("DownloadURL", downloadURL);

    const newStore = { ...item, [imageId]: downloadURL };
    delete newStore["image" + imageId]; // Assuming 'image' is a property you want to remove

    const firestore = firebase.firestore();
    await firestore
      .collection(DB_PATH.AUTHOR)
      .doc(item.id)
      .set(newStore, { merge: true });

    console.log("Image uploaded and store updated successfully.");
  } catch (error) {
    console.error("Error uploading image: ", error);
  }
};
